import { h } from 'preact';
import { Text } from 'preact-i18n';

const FELLESKATALOGEN_BASE = 'https://www.felleskatalogen.no';

function isVetDrug(drug) {
    if (drug.filter === 'Veterinær') {
        return true;
    }
    const preparattype = drug.preparattype || drug.preparattypeDn || '';
    return /^vet\b/i.test(preparattype);
}

/**
 * Felleskatalogen has no derivable per-drug URL, but its search resolves a
 * varenr directly, so we link to a search. Vet drugs go to the vet catalog.
 * Returns '' when there is nothing to search for.
 */
export function getFelleskatalogenUrl(drug) {
    if (!drug) {
        return '';
    }
    const term = drug.varenr || drug.varenavn || drug.navnFormStyrke || drug.navn || '';
    if (!term) {
        return '';
    }
    const catalog = isVetDrug(drug) ? 'medisin-vet' : 'medisin';
    return `${FELLESKATALOGEN_BASE}/${catalog}/sok?sokord=${encodeURIComponent(term)}`;
}

function stopRowClick(e) {
    // The link sits inside a clickable result row; opening Felleskatalogen must
    // not also select the row.
    e.stopPropagation();
}

export default function FelleskatalogenLink({ drug, class: className = '' }) {
    const url = getFelleskatalogenUrl(drug);
    if (!url) {
        return null;
    }
    return (
        <a
            href={url}
            target='_blank'
            rel='noopener noreferrer'
            class={`text-decoration-none text-nowrap ${className}`}
            onClick={stopRowClick}
        >
            <i class='fa-duotone fa-book-medical me-1' />
            <Text id='dyrejournal.drug.felleskatalogen'>Felleskatalogen</Text>
        </a>
    );
}
